import {Button, DatePicker, Form, Input, Select} from "antd";
import {DiscountCodeCreateDto, DiscountCodeUpdateDto, DiscountType} from "../../../api";
import {CrudForm, CrudFormItemProps, nameof} from "digimuth-components/dist";
import React, {useState} from "react";
import {RangePickerProps} from "antd/lib/date-picker";
import {discountTypeTranslation} from "../../../helpers/DiscountTypeHelper";
import dayjs from 'dayjs'

const {Option} = Select;

export default function DiscountCodeModalForm(props: DiscountCodeModalProps) {
    const [selectedDiscountType, setSelectedDiscountType] = useState<DiscountType | null>(null);
    const [discountCode, setDiscountCode] = useState<string>(props.initialValues?.code ?? "");
    const [form] = Form.useForm();

    const onRandomizeCodeClick = () => {
        const randomCode = Math.random().toString(36).substring(2, 10).toUpperCase();
        form.setFieldsValue({"code": randomCode});
        setDiscountCode(randomCode);
    }

    const handleInputChange = (event: any) => {
        setDiscountCode(event.target.value.toUpperCase());
    };

    const disabledDate: RangePickerProps['disabledDate'] = (current) => {
        return current && current < dayjs().startOf('day');
    };

    const initialValues = {
        ...props.initialValues,
        "expirationDate": props.initialValues ? dayjs(props.initialValues?.expirationDate) : null
    };

    const formItems: CrudFormItemProps[] = [
        {
            name: nameof<DiscountCodeCreateDto>("code"),
            label: "Kod rabatowy",
            rules: [
                {
                    required: true,
                    message: 'Kod rabatowy musi składać się z wielkich liter, cyfr oraz myślników',
                    pattern: new RegExp(/^[A-Z0-9-]+$/)
                }
            ],
            children: <div style={{display: "flex"}}>
                <Input onChange={handleInputChange} value={discountCode}/>
                <Button style={{marginLeft: "25px"}} onClick={onRandomizeCodeClick}>
                    Wylosuj kod
                </Button>
            </div>
        }, {
            name: nameof<DiscountCodeCreateDto>("expirationDate"),
            label: "Data ważności",
            children: <DatePicker showTime disabledDate={disabledDate}/>
        }, {
            name: nameof<DiscountCodeCreateDto>("discountType"),
            label: "Typ obniżki",
            rules: [
                {required: true, message: "To pole jest wymagane"}
            ],
            children: <Select onChange={setSelectedDiscountType}>
                {Object.values(DiscountType).map((type, index) => <Option value={type} key={index}>
                    {discountTypeTranslation(type)?.translation}
                </Option>)}
            </Select>
        },
        ...(selectedDiscountType === DiscountType.Quota || selectedDiscountType === DiscountType.Percent) ? [{
            name: nameof<DiscountCodeCreateDto>("discountValue"),
            label: `${selectedDiscountType === DiscountType.Percent ? "Procent obniżki" : "Kwota obniżki"}`,
            rules: [
                {required: true, message: "To pole jest wymagane"}
            ],
            children: <Input type={"number"}/>
        }] : [], {
            name: nameof<DiscountCodeCreateDto>("minimumOrderAmount"),
            label: "Minimalna kwota zamówienia",
            children: <Input type={"number"}/>
        }
    ];

    return <CrudForm
        formItems={formItems}
        form={form}
        onSubmit={props.onSubmit}
        initialValues={initialValues}
        saveButtonTitle={props.saveButtonTitle}
    />;
}

interface DiscountCodeModalProps {
    initialValues?: DiscountCodeCreateDto | DiscountCodeUpdateDto,
    onSubmit: (value: DiscountCodeCreateDto | DiscountCodeUpdateDto) => Promise<any>,
    saveButtonTitle: string,
}
